export default __webpack_public_path__ + "static/media/SheTwo.eb2db1ec.jpg";